module.exports = __webpack_public_path__ + "static/play-store_badge--black-70ab69477ab372f2da669235bd2d9e23.svg";